module.exports = __webpack_public_path__ + "static/media/commutativeOr2.97bbeb5e.JPG";